import api from "src/apis/api"

// Follow-ups are scheduled outreach commitments on a lead or deal. They are
// Task-backed on the server but exposed through their own endpoints.

export async function fetchFollowUps(parentType, parentId) {
  const { data } = await api.get(`/api/v1/${parentType}/${parentId}/follow_ups`)
  return data.follow_ups || []
}

export async function createFollowUp(parentType, parentId, followUp) {
  const { data } = await api.post(`/api/v1/${parentType}/${parentId}/follow_ups`, { follow_up: followUp })
  return data.follow_up
}

export async function updateFollowUp(id, followUp) {
  const { data } = await api.patch(`/api/v1/follow_ups/${id}`, { follow_up: followUp })
  return data.follow_up
}

export async function deleteFollowUp(id) {
  const { data } = await api.delete(`/api/v1/follow_ups/${id}`)
  return data
}

// Mark done + record how the outreach went.
export async function completeFollowUp(id, outcome) {
  const { data } = await api.post(`/api/v1/follow_ups/${id}/complete`, { outcome })
  return data.follow_up
}

// Push to a new date (reopens if it was completed).
export async function rescheduleFollowUp(id, dueAt) {
  const { data } = await api.post(`/api/v1/follow_ups/${id}/reschedule`, { due_at: dueAt })
  return data.follow_up
}
